import React from "react";
import { Form, Radio, FormItemProps, Checkbox } from "antd";
import { CheckboxChangeEvent } from "antd/lib/checkbox";

export interface AntdFormCheckboxFieldProps extends FormItemProps {
  name: string;
  label: string;
  placeholder?: string;
  onChange?: (value: CheckboxChangeEvent) => void
}

const colProps = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

const AntdFormCheckbox: React.FC<AntdFormCheckboxFieldProps> = ({
  name,
  label,
  required,
  placeholder,
  onChange,
  ...otherProps
}) => {
  return (
  <Form.Item name={name} label={label} valuePropName="checked" {...otherProps} {...colProps}>
      <Checkbox onChange={onChange}>{placeholder}</Checkbox>
    </Form.Item>
  );
};

export default AntdFormCheckbox;
